<template>
    <ParentPage page-type="resources-parent-page"></ParentPage>
</template>
<script lang="ts" setup>
    import {useWebsitePageView} from '#imports';
    import ParentPage from '~/components/ParentPage.vue';

    useWebsitePageView('cms', 'resources');
</script>
